<template>
  <div class="flex flex-wrap mb-2" :style="guideStep === 50 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <loading :active="!this.showIdentity || !showIdentityMyside"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading>
      <span class="text-red-500">*</span>
      <span class="text-grap-700 align-middle" @click="helo">{{lang['components']['Event']['Identity']['title']}}</span>
      <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'tooltip'"></i> -->
      <button
        v-if="!editPageType"
        id="identity"
        class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
        @click="teachVideo()"
      >
        {{lang['components']['Event']['Identity']['video_teaching']}}
      </button>
      <div class="flex-1 space-y-4">
        <div class="space-y-2 pb-8">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">Facebook</span>
            <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'目標'"></i> -->
          </div>
          <input type="hidden" name="step_3_facebook" v-model="viewDatalistData.page_id">
          <Dropdown :disabled="editPageType" v-model="viewDatalistData.page_id" optionLabel="name" optionValue="code" :options="viewDatalistData.adpages_list" :placeholder="lang['components']['Event']['Identity']['facebook_placeholder']" class="w-1/3 rounded-md" />
        </div>
        <div class="space-y-2 pb-8">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">IG</span>
            <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'目標成本'"></i> -->
          </div>
          <Dropdown :disabled="true" v-model="viewDatalistData.ig_username" optionLabel="name" optionValue="code" :options="viewDatalistData.ig_list" placeholder="" class="w-1/3 rounded-md" />
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import Dropdown from 'primevue/dropdown';
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'Identity',
    components: {
      Dropdown,
      Loading
    },
    emits: {
      test: val => {
        // console.lo('got');
        // console.log(val);
        return true;
      }
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      showIdentity: {
        type: Boolean
      },
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        showIdentityMyside: true,
        facebook: null,
        ig: null,
        page_id_list: null,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
      }
    },
//     setup(props){
//       // const page_id_list = null
//       let page_id_list = [
// {
// name: "WeClassic 唯典客",
// code: "202560920350072"
// },
// {
// name: "測試",
// code: "320156478569042"
// },
// {
// name: "AutoTurn",
// code: "1055506187980947"
// },
// {
// name: "Future Lab. 未來實驗室",
// code: "1367214356651266"
// }
// ]

//       axios
//         .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_adpages.php')
//         .then((response) => {
//           if(response.data.status == 'success'){
//             page_id_list = response.data.return_data;
//           }
//         });

//       console.log(page_id_list);

//       return {
//                 page_id_list
//               }
//     },
    // created() {
    //   axios
    //     .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_adpages.php', Qs.stringify({
    //       s_code: this.$route.params.id,
    //       adaccount_id: this.$route.params.adaccount_id,
    //     }))
    //     .then((response) => {
    //       if(response.data.status == 'success'){
    //         console.log('response:'+response.data.return_data);
    //         // self.first_name = response.data.firstName;
    //         // this.first_name = response.data.firstName
    //         this.page_id_list = response.data.return_data;

    //         // console.log(page_id_list);
    //       }
    //     });
    // },
    watch: {
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'identity'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      // <!-- 新手教學 -->
      guideStep(val) {
        if (val === 49) {
          this.viewDatalistData.page_id = this.viewDatalistData.adpages_list[0].code;
        }
      },
      // <!-- 新手教學 -->
      'viewDatalistData.page_id': function(v){
        // console.log('watch viewDatalistData.page_id');
        // console.log(v);

        this.$emit('childPageId', v);

        if(v != '' && v != null){
          this.showIdentityMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_page_instagram.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: v,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                console.log('response:'+response.data.return_data);
                // console.log('b this.viewDatalistData.ig_username:'+this.viewDatalistData.ig_username);
                this.viewDatalistData.ig_username = response.data.return_data;
                this.viewDatalistData.ig_id = response.data.ig_id;
                this.viewDatalistData.ig_list = response.data.data_list;
                // console.log('a this.viewDatalistData.ig_username:'+this.viewDatalistData.ig_username);
              }

              this.showIdentityMyside = true;
            });
        }
      }
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingMethod');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_identity')

        this.vars.start = 16
        this.vars.end = 23
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      helo() {
        console.log(this.viewDatalistData);
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>